// extracted by mini-css-extract-plugin
export default {"Fab":"Fab_Fab__tsb2p","FabContainer":"Fab_FabContainer__z0e5i"};